import React from 'react';

const PdfLeftIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11.25" transform="rotate(-180 12 12)" stroke="black" strokeWidth="1.5" />
    <path fillRule="evenodd" clipRule="evenodd" d="M13.6221 15.8023C13.3292 16.0952 12.8544 16.0952 12.5615 15.8023L9.28874 12.5296C8.99585 12.2367 8.99585 11.7618 9.28874 11.4689L12.5615 8.19619C12.8544 7.90329 13.3292 7.90329 13.6221 8.19619C13.915 8.48908 13.915 8.96395 13.6221 9.25685L10.8797 11.9992L13.6221 14.7416C13.915 15.0345 13.915 15.5094 13.6221 15.8023Z" fill="black" />
  </svg>

);

export default PdfLeftIcon;
